import { FC } from 'react'

import { List as MerinioList } from 'ui'
import { t } from 'translations'

type Props = {
  item?: string
  subItem?: string
}

const ListItem: FC<Props> = ({ item, subItem }) => (
  <MerinioList.Item className="d-flex align-items-center">
    <div>
      {item ? <div>{t(item)}</div> : <i>{t('NO_DATA')}</i>}
      {subItem ? <small className="text-muted">{t(subItem)}</small> : null}
    </div>
  </MerinioList.Item>
)

export default ListItem
